module.exports = __webpack_public_path__ + "img/vs-img-mobile.af76e7d4.png";